<template>
  <v-footer app
            class="pa-0"
            :class="`${appTextColour}--text`"
            height="25px"
            :dark="isTooDark(color)"
            color="primary"
            style="line-height: 25px">
    <v-col v-if="config.whitelabel"
           class="py-0"
           style="height: 25px">
      <div v-html="getWhitelabelText()"></div>
    </v-col>
    <v-col style="height: 25px" class="py-0"></v-col>
    <v-col v-if="config.poweredby"
           class="py-0"
           style="height: 25px">
      <v-row no-gutters align="center" justify="end">
        <span
          class="caption mr-1" style="opacity: 0.8">Powered by</span>
        <span v-if="config.poweredby.text">{{config.poweredby.text}}</span>
        <img v-if="config.poweredby.logo"
             @click="handleLinkout(config.poweredby.link)"
             style="max-height: 25px; position: relative; right: 0px; cursor: pointer"
             :src="config.poweredby.logo"/>
      </v-row>
    </v-col>
  </v-footer>
</template>

<script>
  import color from '@/mixins/color';

  export default {
    name: 'TheFooter',

    computed: {
      config() {
        return this.$store.getters['CONFIG'].config.footer;
      },
      color() {
        return this.$vuetify.theme.themes.light['primary'];
      }
    },

    mixins: [color],

    data() {
      return {};
    },

    methods: {
      getWhitelabelText() {
        if (this.config.whitelabel && this.config.whitelabel.text.indexOf('~') > -1) {
          let split = this.config.whitelabel.text.split('~');
          return `<span class="caption" style="opacity: 0.7">Produced by </span><span class="font-weight-bold">${split[0]}</span><span class="font-weight-light">${split[1]}</span>`;
        }
      },
      handleLinkout (url){
        window.open(url, '_blank')
      }
    }
  };
</script>

<style scoped>

</style>
